import { axiosInstance } from "@/helper/axios-instance";
import { DataAwareResponse, UniquePossibilities } from "../types/types";
import { useMutationWithValidation } from "./useMutationWithValidation";

export function useUniquePossibilitiesUpsert() {
  return useMutationWithValidation({
    mutationFn: async (input: { data: Partial<UniquePossibilities>; overwrite: boolean }) => {
      const response = await axiosInstance({
        method: "POST",
        url:
          
          `Household/UpsertUniquePossibilities?overwrite=${input.overwrite}`,
        data: input.data,
      });

      return response.data as DataAwareResponse<UniquePossibilities>;
    },
    retry: 2,
  });
}
